// extracted by mini-css-extract-plugin
module.exports = {"container":"TextExpandable_container__1RQ2d","more":"TextExpandable_more__3dp8t"};